import { getBoolEnv, getEnv } from "@/shared/utils/env-utils";
import { lazy, ReactNode, Suspense } from "react";

export interface AuthProviderProps {
    children: ReactNode;
}

export const AuthProvider = ({ children }: AuthProviderProps) => {
    let AuthProvider: React.ComponentType<{ children: ReactNode }>;

    // Check runtime environment variables (from docker-entrypoint.sh) or build-time (from import.meta.env)
    const viteEnv = getEnv("VITE_ENV");
    const skipAuth = getBoolEnv("VITE_SKIP_AUTH");
    const isDevE2ETest = viteEnv === "dev" || viteEnv === "test" || viteEnv === "e2e";
    const isProductionDomain = typeof window !== "undefined" && window.location.hostname.includes("sein.ns.nl");
    if (skipAuth && isDevE2ETest && !isProductionDomain) {
        // Should be removed from build by vite / rollup tree shaking
        AuthProvider = lazy(() => import("./test-auth-context-provider.tsx"));
    } else {
        AuthProvider = lazy(() => import("./real-auth-context-provider.tsx"));
    }

    return (
        <Suspense fallback={null}>
            <AuthProvider>{children}</AuthProvider>
        </Suspense>
    );
};
